export enum DocumentState {
  DocumentNotMatchedToChase = 100,
  InvalidDocument = 122,
}
